import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { filter, Observable, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectAuthReady } from '../store/auth/auth.selectors';
import { loadingGoodModeActionType } from '../store/goodmode/goodmode.actions';
import { UserRolesEnum } from '../interfaces/user.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthResolver implements Resolve<boolean> {
  constructor(public store: Store) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    this.store.dispatch(
      loadingGoodModeActionType({ params: UserRolesEnum.receiver })
    );

    return this.store.select(selectAuthReady).pipe(
      filter((data: boolean) => {
        return data;
      }),
      take(1)
    );
  }
}
